import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallFlowConfigurationsComponent } from './call-flow-configurations.component';
import { NormalizationBeforeRoutingComponent } from './normalization-before-routing/normalization-before-routing.component';
import {ArmFormModule} from '../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import {InfraModule} from 'ac-infra';
import {ArmSideNavModule} from '../../components/arm-side-nav/arm-side-nav.module';
import {WebServicesComponent} from './web-services/web-services.component';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { WebServiceDialogComponent } from './web-services/web-service-dialog/web-service-dialog.component';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { NormalizationGroupsComponent } from './normalization-groups/normalization-groups.component';
import { NormalizationGroupsDialogComponent } from './normalization-groups/normalization-groups-dialog/normalization-groups-dialog.component';
import { PrefixGroupsComponent } from './prefix-groups/prefix-groups.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import { PrefixGroupsSummaryComponent } from './prefix-groups/prefix-groups-summary/prefix-groups-summary.component';
import { PrefixGroupsSearchComponent } from './prefix-groups/prefix-groups-search/prefix-groups-search.component';
import {InfoTreeModule} from '../../components/info-tree/info-tree.module';
import {DialogModule} from '../../components/dialog/dialog.module';
import {
  PrefixGroupsDialogComponent,
  SearchFilterPipe, SearchTotalFilterPipe
} from './prefix-groups/prefix-groups-dialog/prefix-groups-dialog.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {FlexModule} from '@angular/flex-layout';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';
import {PolicyStudioModule} from './policy-studio/policy-studio.module';
import {SipConditionGroupsComponent} from './sip-condition-groups/sip-condition-groups.component';
import {SipManipulationGroupsComponent} from './sip-manipulation-groups/sip-manipulation-groups.component';
import { SipConditionGroupsDialogComponent } from './sip-condition-groups/sip-condition-groups-dialog/sip-condition-groups-dialog.component';
import {SipManipulationGroupsDialogComponent} from './sip-manipulation-groups/sip-manipulation-groups-dialog/sip-manipulation-groups-dialog.component';
import {HighlightPipe} from './sip-condition-groups/highlight.pipe';
import {OverlayModule} from '@angular/cdk/overlay';
import { SipCustomValueComponent } from './sip-condition-groups/sip-custom-value/sip-custom-value.component';
import {SipConditionGroupsSummaryComponent} from './sip-condition-groups/sip-condition-groups-summary/sip-condition-groups-summary.component';
import {SipManipulationGroupsSummaryComponent} from './sip-manipulation-groups/sip-manipulation-groups-summary/sip-manipulation-groups-summary.component';
import {ArmJsonEditorComponent} from '../../utils/json-editor/arm-json-editor.component';


@NgModule({
  declarations: [CallFlowConfigurationsComponent, NormalizationBeforeRoutingComponent, WebServicesComponent,
    WebServiceDialogComponent, NormalizationGroupsComponent, NormalizationGroupsDialogComponent, PrefixGroupsComponent,
    SipConditionGroupsComponent, SipManipulationGroupsComponent, PrefixGroupsSummaryComponent, PrefixGroupsSearchComponent,
    PrefixGroupsDialogComponent, SearchFilterPipe, SearchTotalFilterPipe,
    SipConditionGroupsDialogComponent, SipConditionGroupsSummaryComponent,
    SipManipulationGroupsDialogComponent, SipManipulationGroupsSummaryComponent, HighlightPipe, SipCustomValueComponent,
    ArmJsonEditorComponent],
  imports: [
    CommonModule,
    ArmFormModule,
    ArmFormTitleModule,
    PolicyStudioModule,
    InfraModule,
    ArmSideNavModule,
    ActionBarModule,
    MaterialModule,
    FormsModule,
    ArmTableModule,
    LayoutModule,
    SearchModule,
    InfoTreeModule,
    DialogModule,
    ClipboardModule,
    FlexModule,
    ClientFilterModule,
    ReactiveFormsModule,
    OverlayModule
  ]
})
export class CallFlowConfigurationsModule { }
